@if (showUpdateNotification) {
  <div class="update-notification">
    A new version is available. <button (click)="reloadPage()">Reload</button>
  </div>
}
<router-outlet />
<ngx-ui-loader fgsColor="#000"></ngx-ui-loader>
